import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const datadog = defineConnector({
  identifier: "datadog",
  name: "Datadog",
  tagLine: "Cloud monitoring and analytics",
  keywords:
    "dd apm observability logs metrics traces rum synthetics dashboards siem",
  logo,
  protocol: "http",
  tags: ["featured", "it", "observability", "data"],
  defaultUrlPattern: () =>
    "https://api\\.(?:[^/]*\\.)?(datadoghq\\.(com|eu)|ddog-gov\\.com)/.*",
  auth: (app) =>
    headerAuth([
      { name: "DD-API-KEY", value: app.secret.apiKey },
      { name: "DD-APPLICATION-KEY", value: app.secret.appKey },
    ]),
  steps: [
    {
      title: "Select your Datadog site",
      items: [
        {
          kind: "select",
          label: "Datadog site",
          required: true,
          target: { kind: "configuration", field: "site" },
          options: [
            { value: "datadoghq.com", label: "US1 (datadoghq.com)" },
            { value: "us3.datadoghq.com", label: "US3 (us3.datadoghq.com)" },
            { value: "us5.datadoghq.com", label: "US5 (us5.datadoghq.com)" },
            { value: "datadoghq.eu", label: "EU (datadoghq.eu)" },
            { value: "ap1.datadoghq.com", label: "AP1 (ap1.datadoghq.com)" },
            { value: "ap2.datadoghq.com", label: "AP2 (ap2.datadoghq.com)" },
            { value: "ddog-gov.com", label: "US1-FED (ddog-gov.com)" },
          ],
          defaultValue: "datadoghq.com",
          helperText: "Select the Datadog site your organization uses.",
        },
      ],
    },
    {
      title: "Get your API and application keys",
      items: [
        {
          kind: "markdown",
          content:
            "In your Datadog console, navigate to **Organization Settings > API Keys** to create or copy your API key, then go to **Application Keys** to create an application key.",
        },
      ],
    },
    {
      title: "Copy and paste the keys into the fields below",
      items: [
        {
          kind: "input",
          label: "Datadog API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "Datadog application key",
          required: true,
          target: { kind: "secrets", field: "appKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ site }) => `https://api.${site}/api/v1/validate`,
  },
  publicEnvVars: ({ site }) => ({ DATADOG_SITE: site || "" }),
});
